import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const OfflineOneDriveParachuteIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg}>
      <path d="M960 1408q66 0 124 25t101 69 69 102 26 124q0 66-25 124t-69 102-102 69-124 25q-66 0-124-25t-102-68-69-102-25-125q0-66 25-124t68-101 102-69 125-26zm0 512q40 0 75-15t61-41 41-61 15-75q0-40-15-75t-41-61-61-41-75-15q-40 0-75 15t-61 41-41 61-15 75q0 40 15 75t41 61 61 41 75 15zM960 0q132 0 254 34t230 97 194 150 150 195 97 229 35 255v31l-596 477q-19-26-41-49t-48-44l548-439q-90-35-184-53t-192-19q-99 0-195 19t-188 56v346q-16-2-32-3t-32-2q-16 0-32 1t-32 4V940q-185-76-385-76-97 0-190 18t-184 54l548 439q-26 20-48 43t-41 50L0 991v-31q0-132 34-254t97-230 150-194 195-150 229-97T960 0zm8 824q107-42 214-65t223-23q190 0 370 62-29-145-104-268t-183-212-244-140-284-50q-149 0-284 50T433 317 249 529 145 797q181-61 369-61 55 0 112 5t115 17 113 29 106 40l8-3z" />
    </svg>
  ),
  displayName: 'OfflineOneDriveParachuteIcon',
});

export default OfflineOneDriveParachuteIcon;
